import React, {FC} from 'react'
import {UseFormRegister, FieldErrors} from 'react-hook-form'
type InputProps = {
  name: string
  register: UseFormRegister<any>
  errors: FieldErrors
  disabled?: boolean
}

const InputSwitch: FC<InputProps> = ({name, register, errors, disabled = false, ...props}) => {
  return (
    <div className='sdx_form_input '>
      <div className='form-check form-switch'>
        <input
          {...register(name)}
          className='form-check-input'
          type='checkbox'
          role='switch'
          disabled={disabled}
        />
      </div>
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputSwitch
